/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const countContactsHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Contact owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Contact count
 */
export const countContacts200Schema = z.object({
    "count": z.int().min(-9007199254740991).max(9007199254740991)
    })

export const countContactsQueryResponseSchema = z.lazy(() => countContacts200Schema)